import React, { useEffect, useState } from 'react';
import { AppStoreButton } from './AppStoreButton';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white ${isScrolled ? 'shadow-sm py-3' : 'py-4'}`} data-id="element-60">
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center" data-id="element-61">
        <div className="text-2xl font-black tracking-tight text-black" data-id="element-62">
          Croon.
        </div>
        <AppStoreButton data-id="element-63" />
      </div>
    </nav>;
}